import apiClient from './api-client'

export default {
  list: () => apiClient.get('/feature-flags'),

  create: label => apiClient.post('/feature-flags', { label }),

  delete: id => apiClient.destroy(`/feature-flags/${id}`),

  listPracticeFlags: practiceId =>
    apiClient.get(`/feature-flags/${practiceId}/practices`),

  attach: (featureFlagId, practiceId) =>
    apiClient.post(`/feature-flags/${featureFlagId}/practices/${practiceId}`),

  detach: (featureFlagId, practiceId) =>
    apiClient.destroy(
      `/feature-flags/${featureFlagId}/practices/${practiceId}`,
    ),
}
